module.exports = __webpack_public_path__ + "img/PAMMAccountRunPrinciple.2c907d1b.png";